import httpClient from '@/http-client'

export const sale = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-profiles/sales', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/customer-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/customer-profiles/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/customer-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const type = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-profiles/types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-profiles/provinces')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-profiles/districts/${province_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-profiles/communes/${district_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-profiles/villages/${commune_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const approveMulti = data => {
  return httpClient
    .post('/api/v1/customer-profiles/approve-multiples', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-profiles/form-view-models`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const customerExportExcel = data => {
  return httpClient
    .post('/api/v1/customer-profiles/export-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}


export default { get, find, store, update, destroy, type, sale, province, district, commune, village, formViewModel, approveMulti, customerExportExcel }
